import { render, staticRenderFns } from "./nota-print.vue?vue&type=template&id=1f5f1d2e&scoped=true&"
import script from "./nota-print.vue?vue&type=script&lang=js&"
export * from "./nota-print.vue?vue&type=script&lang=js&"
import style0 from "./nota-print.vue?vue&type=style&index=0&id=1f5f1d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5f1d2e",
  null
  
)

export default component.exports